var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#12B76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5804 15.5816C10.3804 15.5816 10.1904 15.5016 10.0504 15.3616L7.22043 12.5316C6.93043 12.2416 6.93043 11.7616 7.22043 11.4716C7.51043 11.1816 7.99043 11.1816 8.28043 11.4716L10.5804 13.7716L15.7204 8.63156C16.0104 8.34156 16.4904 8.34156 16.7804 8.63156C17.0704 8.92156 17.0704 9.40156 16.7804 9.69156L11.1104 15.3616C10.9704 15.5016 10.7804 15.5816 10.5804 15.5816Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.f5f43f743106c6d48e70972ed062872a.svg";
export { ForwardRef as ReactComponent };